
define('text!modules/creatives/bulkedit/templates/assign_body.html',[],function () { return '<div class="form-stack">\n\t<creatives-classification-assignment id="creativeAssignments" fitparent unresolved></creatives-classification-assignment>\n</div>';});

